import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import AlertsOverview from "@/modules/alerts/pages/AlertsOverview.vue";
import AlertPage from "@/modules/alerts/pages/AlertPage.vue";

export default new Route(
	"alerts",
	"/alerts",
	RouterView,
	[
		new Route("alerts.index", "", AlertsOverview, [], {}),
		new Route("alerts.view", ":id", AlertPage, [], {}),
	],
	{ permissions: [] }
);
